import React, { useEffect, useState } from 'react';
import StickyCta from '../StickyCta';
import StickyBottomModal from '../StickyModal';
import VariantPickerContainer from './VariantPickerContainer';
import CustomVariantContainer from './CustomVariantContainer';
import StockStatusTag from '../StockStatusTag';
import BuyButton from '../BuyButton';
import { translate } from '../../Services/translation';
import { CaretDown } from 'phosphor-react';
import QuantityBuyButton from './QuantityBuyButton';
import RelationAndGuides from './RelationAndGuides';
import SizeRelationSection from './SizeRelationSection';

const getBuyButtonLabel = (hasSeveralVariants, selectedVariant) => {
  if (hasSeveralVariants) {
    return selectedVariant != null
      ? translate('product-page.buy-button')
      : translate('product-page.select-variant');
  } else {
    return translate('product-page.buy-button');
  }
};

const getModalLabel = (isConfigurator) => {
  if (isConfigurator) {
    return translate('product-page.choose-size-and-buy');
  } else {
    return translate('product-page.choose-size');
  }
};

const MobileStickyBuyButton = (props) => {
  const [modalOpen, setOpen] = useState(false);
  const hasSeveralVariants = props.productItem.variants.length > 1;
  const [selectedVariant, setSelectedVariant] = useState(
    hasSeveralVariants ? null : props.productItem.variants[0]
  );
  const onVariantSelected = (variant) => {
    setSelectedVariant(variant);
    setOpen(false);
  };

  return (
    <StickyCta>
      <div className="sticky-pdp-container__top d-flex justify-between">
        <div className="[ product-page__name ] [ text-medium ]">
          {props.productItem.name}{' '}
          {props.productItem?.variants.length <= 1 &&
            !props.productItem.hasConfigurator && (
              <span>{'- ' + props.productItem.size}</span>
            )}
        </div>
        {selectedVariant ? (
          <div>
            {selectedVariant.price?.formattedCampaignPrice ? (
              <>
                <span className="product-page__price--campaign-price">
                  {selectedVariant.price?.formattedCampaignPrice}
                </span>
                <span className="[ product-page__price--original ] [ color-grey-900 text-small ]">
                  {selectedVariant.price?.formattedPrice}
                </span>
              </>
            ) : (
              <span className="text-medium bold color-grey-900">
                {selectedVariant.price?.formattedPrice}
              </span>
            )}
          </div>
        ) : (
          <div>
            {props.productItem.price?.formattedCampaignPrice ? (
              <>
                <span className="product-page__price--campaign-price">
                  {props.productItem.price?.formattedCampaignPrice}
                </span>
                <span className="[ product-page__price--original ] [ color-grey-900 text-small ]">
                  {props.productItem.price?.formattedPrice}
                </span>
              </>
            ) : (
              <span className="text-medium bold color-grey-900">
                {props.productItem.price?.formattedPrice}
              </span>
            )}
          </div>
        )}
      </div>
      {selectedVariant && props.isBuyableChannel && (
        <StockStatusTag
          description={selectedVariant.stockStatusDescription}
          stockStatusType={selectedVariant.stockStatusType}
        />
      )}
      <div className="sticky-pdp-container__bottom">
        {props.configuratorViewModel ? (
          <div className="buy-button" onClick={() => setOpen(true)}>
            {translate('product-page.choose-size-and-buy')}
          </div>
        ) : (
          <>
            {hasSeveralVariants ? (
              <div className="sticky-pdp-container__variant-select-wrapper">
                <div
                  className="sticky-pdp-container__variant-select [ justify-center align-center d-flex ]"
                  onClick={() => setOpen(true)}
                >
                  {selectedVariant ? (
                    selectedVariant.size
                  ) : (
                    <div className="d-flex justify-between">
                      {translate('product-page.select-variant')}{' '}
                      <CaretDown size={16} />
                    </div>
                  )}
                </div>
                {props.isBuyableChannel ? (
                  <>
                    {props.isB2b ? (
                      <QuantityBuyButton
                        selectedVariantArtNumber={
                          selectedVariant && selectedVariant.id
                        }
                        label={getBuyButtonLabel(
                          hasSeveralVariants,
                          selectedVariant
                        )}
                      />
                    ) : (
                      <BuyButton
                        articleNumber={selectedVariant && selectedVariant.id}
                        quantity={1}
                        label={getBuyButtonLabel(
                          hasSeveralVariants,
                          selectedVariant
                        )}
                      />
                    )}
                  </>
                ) : (
                  props.storesUrl && (
                    <a className="buy-button" href={props.storesUrl}>
                      {translate('product-page.find-your-store')}
                    </a>
                  )
                )}
              </div>
            ) : props.isBuyableChannel ? (
              <BuyButton
                articleNumber={props.productItem.variants[0].articleNumber}
                quantity={1}
                label={getBuyButtonLabel(hasSeveralVariants, selectedVariant)}
              />
            ) : (
              props.storesUrl && (
                <a className="buy-button" href={props.storesUrl}>
                  {translate('product-page.find-your-store')}
                </a>
              )
            )}
          </>
        )}
      </div>
      <StickyBottomModal
        title={getModalLabel(props.configuratorViewModel)}
        open={modalOpen}
        onClose={() => setOpen(false)}
        extraContentAbove={
          !props.configuratorViewModel && <RelationAndGuides {...props} />
        }
      >
        {props.configuratorViewModel ? (
          <>
            <CustomVariantContainer
              configurations={props.configuratorViewModel.configuratorPanels}
              isBuyableChannel={props.isBuyableChannel}
            />
            {props.otherUnitProduct?.url && (
              <SizeRelationSection {...props.otherUnitProduct} />
            )}
          </>
        ) : (
          <>
            <VariantPickerContainer
              hideQuantityField={true}
              hideBuyButton={true}
              productVariants={props.variants}
              onVariantSelected={onVariantSelected}
              isBuyableChannel={props.isBuyableChannel}
            />
            {props.otherUnitProduct?.url && (
              <SizeRelationSection {...props.otherUnitProduct} />
            )}
          </>
        )}
      </StickyBottomModal>
    </StickyCta>
  );
};

export default MobileStickyBuyButton;
